import { render, staticRenderFns } from "./PaymentMethodGroup.vue?vue&type=template&id=4d1aef78&scoped=true&"
import script from "./PaymentMethodGroup.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodGroup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodGroup.vue?vue&type=style&index=0&id=4d1aef78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1aef78",
  null
  
)

export default component.exports